<div class="card mb-2">
	<div class="row">
		<h2>Presupuestos</h2>
	</div>
</div>
<!--<div class="card mb-2">
	<div class="card-header">
		<h3>1. Facturas por emitir</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="form-group">
				<label for="cash">Bolsa de facturas no emitidas
					<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
						*</span></label>
			</div>
		</div>
	</div>
</div>
<div class="card mb-2">
	<div class="card-header">
		<h3>2. Facturas emitidas durante el dia</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="form-group">
				<label for="cash">Listado de facturas
					<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
						*</span></label>
			</div>
		</div>
	</div>
</div>
<div class="card mb-2">
	<div class="card-header">
		<h3>3. Analisis de Datos</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="form-group">
				<label for="cash">Comparacion entre ventas y presupuestos.
					<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
						*</span></label>
			</div>
		</div>
	</div>
</div>-->
<div class="card mb-2">

	<div class="card-header">
		<h3>1. Crear/Editar Presupuesto</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<div class="form-group mt-2">
					<label for="yearSelect">Año <span class="text-danger"><i class="fa fa-asterisk"></i></span></label>
					<select id="yearSelect" class="form-select" [(ngModel)]="myYear" (change)="onMonthSelect(myYear,0)">
						<option value="undefined">Selecciona un año</option>
						<option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
					</select>
				</div>
			</div>
			<div class="col">
				<div class="form-group mt-2">
					<label for="monthSelect">Mes <span class="text-danger"><i class="fa fa-asterisk"></i></span></label>
					<select id="monthSelect" class="form-select" [(ngModel)]="myMonth"
						(change)="onMonthSelect(myMonth,1)">
						<option value="">Selecciona un mes</option>
						<option *ngFor="let month of availableMonth" [value]="month">{{ month }}</option>
					</select>
				</div>
			</div>
			<div class="col">
				<div class="form-group mt-2">
					<label for="monthSelect">Bodega <span class="text-danger"><i
								class="fa fa-asterisk"></i></span></label>
					<select id="monthSelect" class="form-select" [(ngModel)]="myWarehouse"
						(change)="onMonthSelect(myWarehouse,2)">
						<option value="undefined">Selecciona una bodega</option>
						<option *ngFor="let warehouse of availableWarehouse" [value]="warehouse.id">{{ warehouse.name }}
						</option>
					</select>
				</div>
			</div>

			<div class="col button-container">
				<!-- <button class="btn btn-primary " (click)="onMonthSelect()" [disabled]="!myMonth || !myYear || !myWarehouse">
					<i *ngIf="!searching" class="fa fa-search"></i>
					<span *ngIf="searching" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span>BUSCAR
				</button> -->
				<div [tooltip]="(!myMonth || !myYear || !myWarehouse)?'Completa los campos requeridos':''">
					<button class="btn btn-success" (click)="saveBudget()"
						[disabled]="saving || !myMonth || !myYear || !myWarehouse">
						<i *ngIf="!saving" class="fa fa-save"></i>
						<span *ngIf="saving" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span>{{editing?'ACTUALIZAR':'GUARDAR'}}
					</button>
				</div>
			</div>
		</div>
		<br>
		<div>
			<div>
				<table class="table table-bordered" *ngIf="displayNomenclature.length > 0">
					<thead>
						<tr>
							<!--  <th>level</th> -->
							<th class="nom table-header">Nomenclatura</th>
							<th class="table-header">Cuenta</th>
							<th class="table-header td-center">Presupuesto</th>
							<th class="table-header"></th>
						</tr>
					</thead>

					<tbody>
						<ng-container *ngFor="let x of displayNomenclature; let i = index;">
							<tr [ngClass]="'level'+x.level" *ngIf="x.showed">
								<td [ngClass]="'padding-level'+x.level"><i *ngIf="!x.last" (click)="show(x)"
										[ngClass]="x.showing?'fa fa-angle-up':'fa fa-angle-down'"
										class="clickeable"></i>{{x.displayId}}</td>
								<td *ngIf="x.level == 1 || x.level == 2 || x.level == 3 || x.level == 4">{{x.name}}</td>
								<td *ngIf="x.level == 5 && ((x.displayId.substring(0, 2) == '41') || (x.displayId.substring(0, 1) == '5' && x.displayId.substring(0,3) != '521'))">
									<!-- <ng-container
										*ngIf="(x.displayId+'').includes('411') || (x.displayId+'').includes('412')">
										<app-input-autocomplete [allBorderRadius]="true" [inputs]="input.client"
											[placeholder]="'Ingresa el nombre de un cliente'" [filterElements]="filterClients"
											[typeElements]="'client'+x.displayId" (changeMethod)="verifiedInput($event.event)"
											(inputMethod)="handleInput($event.event)"
											(getTitle)="$event.filterElement.title = $event.filterElement.name"
											(changeStatus)="selectClient($event.filterElement,1)"></app-input-autocomplete>
									</ng-container>
									<ng-container
										*ngIf="!(x.displayId+'').includes('411') && !(x.displayId+'').includes('412')">
										<input type="text" class="form-control" [(ngModel)]="x.name" placeholder="Nombre" />
									</ng-container> -->
									<div class="input-group">
										<app-input-autocomplete [allBorderRadius]="true"
											[inputs]="inputClients[x.displayId]"
											[placeholder]="(x.displayId.substring(0, 1) == '5')?'Ingresa el nombre de un proveedor':'Ingresa el nombre de un cliente'"
											[filterElements]="inputClients[x.displayId].filterElements"
											[typeElements]="'c'+x.displayId"
											(changeMethod)="verifiedInput($event.event)"
											(inputMethod)="handleInput($event.event, inputClients[x.displayId], x)"
											(getTitle)="$event.filterElement.title = $event.filterElement.name"
											(changeStatus)="selectClient($event.filterElement,inputClients[x.displayId], x)"></app-input-autocomplete>
									</div>
								</td>
								<td *ngIf="x.level == 5 && ((x.displayId.substring(0, 2) != '41') && (x.displayId.substring(0, 1) != '5') || x.displayId.substring(0, 3) == '521')">
									<input id="{{'n'+x.displayId}}" class="form-control"
										(input)="changedClient($event, x)" type="text"
										placeholder="Ingresa un nombre para el presupuesto" name="nombre" id="nombre"
										[(ngModel)]="x.name">
								</td>
								<td [colSpan]="x.level < 4?2:1"
									*ngIf="x.level === 5 || x.level === 4 || x.level === 3 || x.level === 2 || x.level === 1">
									<input id="{{'b'+x.displayId}}" type="text" class="form-control"
										[disabled]="!myMonth || !myYear || !myWarehouse" [(ngModel)]="x.budgetString"
										(input)="x.budget = $event.target.value * 1; updateBudget(x)"
										[placeholder]="(!myMonth || !myYear || !myWarehouse)?'Completa los campos requeridos':'Ingresa presupuesto'"
										style="text-align: center;" (focus)="removeCommas(x)" (blur)="putCommas(x)" />
								</td>
								<td class="td-center" *ngIf="x.level === 4">
									<span class="clickeable" style="color: var(--bg-bs-servicios);"
										(click)="addRow(x, i)">
										<i tooltip="Agregar nueva fila" class="a-hover fa fa-plus"
											uib-tooltip="Agregar"></i>
									</span>
								</td>
								<td class="td-center" *ngIf="x.level === 5">
									<span class="clickeable text-danger" (click)="removeRow(x, i)">
										<i tooltip="Eliminar la fila" class="a-hover fa fa-trash"
											uib-tooltip="Eliminar"></i>
									</span>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
				<datalist id="clients">
					<option *ngFor="let opcion of filterClients" [value]="opcion.name"></option>
				</datalist>
				<div class="container-loader" *ngIf="displayNomenclature.length == 0">
					<div class="loader">

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!--<div class="card mb-2">
	<div class="card-header">
		<h3>5. Edicion de Parametros</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="form-group">
				<label for="cash">
					<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
						*</span></label>
			</div>
		</div>
	</div>
</div> -->
<!-- <button class="btn btn-info update-button" (click)="actualizarPresupuestos()" *ngIf="showUpdateButton">
	<i class="fa-solid fa-arrows-rotate"></i>ACTUALIZAR
</button> -->
<span class="span-fixed" *ngIf="editing"><i class="fa fa-circle-info"></i>Estás editando el presupuesto
	<b>{{editing.year}}-{{availableMonth[editing.month-1]}}</b> de la bodega <b>{{warehouseName[editing.warehouse]}}</b></span>